import { observer } from 'mobx-react-lite';
import { FC, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import i18 from 'src/i18n';
import { Router } from 'src/router/router';

import './styles/index.scss';
import { RootStore, RootStoreProvider } from './store';

export const App: FC = observer(function App() {
  const navigate = useNavigate();
  const [store] = useState(() => new RootStore({ navigate, i18 }));

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', store.theme.theme);
  }, [store.theme.theme]);

  useEffect(() => {
    store.initialize();
  }, [store]);

  if (!store.isInitialized) return null;

  return (
    <RootStoreProvider store={store}>
      <Router />
    </RootStoreProvider>
  );
});
